@if (!isLoading) {
  <div class="payment-container">
    <mat-card class="payment-card p-0">
      <mat-card-header class="payment-header">
        <mat-card-title>
          @if (daysRemaining != null && daysRemaining >= 0) {
            <h1 class="payment-title p-2">
              🚨 Payment Overdue!
            </h1>
          }
          @if (daysRemaining != null && daysRemaining > -3 && daysRemaining < 0) {
            <h1 class="payment-title p-2"
              >
              ⚠️ Payment Due Soon!
            </h1>
          }
        </mat-card-title>
      </mat-card-header>
      <mat-card-content class="payment-content">
        <p class="payment-description">
          Your workspace <strong>{{ activeAccount.account.accountName }}</strong> is
          @if (daysRemaining && daysRemaining >= 0) {
            <span><b>past due</b></span>
          }
          @if (daysRemaining && daysRemaining > -3 && daysRemaining < 0) {
            <span><b>approaching its due date</b></span>
            }.
            Please complete your payment to avoid any disruption in Salesmax services or permanent deletion of data.
          </p>
          @if (activeAccount.account?.lastPaymentData?.amount != null) {
            <h1>Due Amount : {{(activeAccount.account?.lastPaymentData?.amount || 0)/100}}</h1>
          }
          <!-- Payment Options -->
          <div class="cta-group d-flex flex-row w-100 align-items-center">
            <button mat-raised-button color="primary" class="btn-pay btn-block" (click)="payNow()">
              💳 Pay Online Now
            </button>
            <mat-icon (click)="copyPaymentLink()" style="cursor: pointer;" matTooltip="Copy Payment Link">content_copy</mat-icon>
          </div>
          <div class="alternate-payment" style="margin: 20px 0;">
            <mat-divider></mat-divider>
            <div class="bank-transfer-section">
              <h3>🏦 Prefer Direct Bank Transfer?</h3>
              <div class="bank-details" style="background: #f9f9fa; border-radius: 8px; padding: 16px; margin-top: 8px;">
                <p>
                  <b>Bank Name:</b> {{bankAccount.bankName}}<br>
                  <b>Account Number:</b> {{bankAccount.accountNumber}}<br>
                  <b>IFSC:</b> {{bankAccount.ifsc}}<br>
                  <b>Account Holder:</b> {{bankAccount.accountHolderName}}<br>
                  <b>Type of Account:</b> {{bankAccount.typeOfAccount}}
                </p>
                <p style="font-size: 12px; color: #888;">(After transfer, please send the payment confirmation to our
                support team below.)</p>
              </div>
            </div>
          </div>
          <!-- Support Section -->
          <mat-divider class="my-3"></mat-divider>
          <div class="support-section" style="margin-top: 10px;">
            <h3>Need Billing Help?</h3>
            <p>
              For billing queries, <a href="https://wa.me/919902127389" target="_blank"
            style="color: #25D366; font-weight: 500;">message us on WhatsApp</a>
            or ping us in the support channel.
          </p>
          <button mat-raised-button color="accent" class="hvr-grow btn-block" (click)="openSupportChat()">Chat With
          Us</button>
          <div class="secondary-actions" style="margin-top: 20px;">
            <button color="warn" class="btn-secondary btn-block" routerLink="/sign-out">
              🚪 Sign Out
            </button>
          </div>
          <div class="d-flex flex-row justify-content-center">
            @if (showDashboardOption) {
              <h2 style="cursor: pointer;" (click)="backToDashboard()">Back to dashboard!!</h2>
            }
          </div>
        </div>
        <!-- Workspace Switch Section -->
        @if (availableMemberships?.length > 0) {
          <div class="workspace-switch">
            <mat-divider class="my-3"></mat-divider>
            <h3 class="workspace-title">🔄 Switch to Another Workspace</h3>
            <mat-chip-listbox aria-label="available account" selectable="true" class="chip-container">
              @for (membership of availableMemberships; track membership) {
                <mat-chip-option style="cursor: pointer; background-color: #3059C8; color: white;" #c
                  [value]="membership" color="primary"
                  (selectionChange)="toggleSelection($event)">
                  {{membership.account.accountName | titlecase}}&nbsp;
                  @if (membership.userAccountStatus && membership.userAccountStatus == 'APPROVED') {
                    <span>- You Have Been
                    Invited</span>
                    }&nbsp;&nbsp;
                  </mat-chip-option>
                }
              </mat-chip-listbox>
            </div>
          }
        </mat-card-content>
      </mat-card>
    </div>
  }





